/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import { constant } from 'lodash';
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { textCustomComparator } from '../../../contactType/components/tableHead';
import * as Styles from '../../../Maintain/client/Components/StyleConstant';
import {
  setSelManIdAction
} from '../store/actions';

const CalculatedInterestManufacturerTable = ({
  fullScreen,
  setFullScreen,
  filters,
  referenceData,
  reportData,
  setSelManId,
  onRowSelect
}) => {
  const MAN_HEAD = [
    {
      headerName: 'Select All',
      field: 'checkSelect',
      maxWidth: Styles.Width_150,
      headerCheckboxSelection: true, // For header check box
      checkboxSelection: true,
      filter: false,
      editable: false,
      suppressMenu: true,
      sortable: false,
      pdfExportOptions: {
        skipColumn: true,
      },
      cellStyle: { 'border-right-color': Styles.BorderColor },
    },
    {
      headerName: 'Manufacturer Id',
      field: 'mfgId',
      minWidth: 160,
      maxLength: Styles.Length_255,
      maxWidth: Styles.Width_250,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      editable: false,
      cellStyle: { 'border-right-color': Styles.BorderColor },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Manufacturer Name',
      field: 'mfgName',
      minWidth: 160,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      sortable: true,
      cellStyle: { 'border-right-color': Styles.BorderColor },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
  ];

  const [columnDefs, setColumnDefs] = useState(MAN_HEAD);

  const [fullScreenView, setFullScreenView] = useState(false);
  const [tableCount, setTableCount] = useState(0);
  const [gridApi, setGridApi] = useState(null);
  const dispatch = useDispatch();
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    // setColumnApi(params.columnApi);
    // setTableCount(params.api.getDisplayedRowCount());
  }, []);
  useEffect(() => {
    resetFilters();
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi]);

  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    setFullScreen(!fullScreenView);
  };
  const onSelectionChanged = useCallback(() => {
    const selRow = [];
    gridApi.getSelectedRows().forEach((element) => {
      selRow.push(element.mfgId);
    });
    setSelManId(selRow);
    dispatch(setSelManIdAction(selRow));
    localStorage.setItem('selectedMfgIds', JSON.stringify(selRow));    
  }, [gridApi]);
useEffect(() => {
  if (gridApi && reportData?.length) {
    const stored = JSON.parse(localStorage.getItem('selectedMfgIds') || '[]');
    gridApi.forEachNode((node) => {
      if (stored.includes(node.data.mfgId)) {
        node.setSelected(true);
      }
    });
  }
}, [gridApi, reportData]);

  return (
    <div className="tBillPanel custom-check">
      <div className="table-container p-0 eightRecords col-12 no-border mt-2 viewcalcmfgTbl">
        <TableGridWithFeatures
          data-testid="CAL-MFG-table"
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenView}
          applyFilter={false}
          rowSelection="multiple"
          onGridReady={onGridReady}
          gridHeight={fullScreenView ? '100vh' : 350}
          rowData={reportData}
          columnDefs={columnDefs}
          exportFile
          sideBar={false}
          singleClickEdit={false}
          fileName="View Calc Interest - Mfg"
          onSelectionChanged={onSelectionChanged}
          onSelect={(e) => onRowSelect(e.api?.getSelectedRows())}
        />
      </div>
    </div>
  );
};
export default CalculatedInterestManufacturerTable;
